import type { ReactNode } from 'react';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { getHelpHtml } from '../../utils/help/help-content';

export function SectionTitle({
  title,
  helpKey,
  subtitle,
  action,
}: {
  title: ReactNode;
  helpKey?: string;
  subtitle?: ReactNode;
  action?: ReactNode;
}) {
  const helpHtml = helpKey ? getHelpHtml(helpKey) : '';

  return (
    <div className="d-flex align-items-start justify-content-between gap-3">
      <div>
        <h2 className="d-inline-flex align-items-center gap-2 fw-semibold text-1000 fs-0 mb-0">
          {title}
          {helpHtml ? <HelpTooltip html={helpHtml} /> : null}
        </h2>
        {subtitle ? <p className="fs--2 text-700 mb-0">{subtitle}</p> : null}
      </div>
      {action}
    </div>
  );
}
